import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
	ShopBagItemContainer,
	ItemContainer,
} from './shopBagItemStyles';

import ItemImage from './ItemImage';
import ItemDescription from './ItemDescription';
import CheckoutButton from './CheckoutButton';

class ShopBagItem extends PureComponent {

	static propTypes = {
		listing: PropTypes.object.isRequired,
		store: PropTypes.object.isRequired,
		products: PropTypes.array.isRequired,
		remove: PropTypes.func.isRequired,
	};

	render() {
		const { listing, store, products, remove } = this.props;
		const cartProduct = products[0];
		const productId = cartProduct.productInstance.product.id;
		const isEcom = typeof cartProduct.subscriptionTypeTerm === 'undefined';
		const xoLink = `/checkout?listing_id=${listing.id}&product_instance_id=${cartProduct.productInstance.id}`;
		const listingHref = isEcom ? xoLink : `/subscription-box/${listing.slug}/?product_id=${productId}`;
		const name = isEcom ? cartProduct.productInstance.product.name : store.name;
		const image = isEcom && cartProduct.productInstance.product.image ? cartProduct.productInstance.product.image : listing.image;

		return (
			<ShopBagItemContainer>
				<ItemContainer>
					<ItemImage
						href={listingHref}
						image={image}
					/>
					<ItemDescription
						href={listingHref}
						remove={remove}
						cartProductId={cartProduct.id}
						productId={productId}
						productInstanceId={cartProduct.productInstance.id}
						subscriptionTypeTermId={cartProduct.subscriptionTypeTerm && cartProduct.subscriptionTypeTerm.id}
						name={name}
					/>
				</ItemContainer>
				<CheckoutButton
					href={xoLink}
					slug={listing.slug}
				/>
			</ShopBagItemContainer>
		);
	}
}


export default ShopBagItem;
